import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/resume-summary-generator/SummaryGeneratorContent.tsx");
